import { countries } from "@/model/consts/countries";
import { XmlRequest } from "@/services/rest/xml-request";
import { getRequiredAttribute, getRequiredChild, getRequiredValue } from "@/utils/xml-helper-functions";
import { LocalizedError } from "@/services/rest/errors";
import { AbstractPointSettingsMessageHandler } from "@/services/rest/messages/system/point-settings-message-handler";
import { PointSettings } from "@/model/point-settings";

export interface ApplicationStartResult {
    sessionCode: string;
    pointSettings: PointSettings;
}
// @typescript-eslint/no-unused-vars
export class AGe22ApplicationStartMessageHandler extends AbstractPointSettingsMessageHandler<ApplicationStartResult> {
    protected readonly requestType: string = "A.GE.2.2";

    constructor (readonly countryId?: number) {
        super();
    }

    buildRequest (request: XmlRequest) {
        const countryCode = countries.getById(this.countryId)?.alpha2 ?? "";
        request.addChildWithValue(request.head, "country", countryCode);
        request.addChild(request.body, "action", {
            type: this.requestType
        });
    }

    parseMessageBody (body: Element, head: Element): ApplicationStartResult {
        const action = getRequiredChild(body, "action");
        const serverCode = getRequiredAttribute(action, "servercode");
        if (serverCode === "1020") {
            const sessionCode = getRequiredChild(head, "sessioncode");
            return {
                sessionCode: getRequiredValue(sessionCode),
                pointSettings: this.parsePoint(action)
            };
        } else {
            throw new LocalizedError(`errors.mtl.aGe22.code${serverCode}`);
        }
    }
}
